/** @file slot.clear: empties one tile slot (its image leaves the document when nothing else uses it). */
import type { CommandDef } from '../apply/commandDef';
import { readInput } from '../validate/readInput';
import { findSlot } from './findSlot';

/** `slot.clear { slot }` → `{}`; an empty slot is a no-op; inverse: `slot.fill` with the previous image and fit. */
export const slotClearCommand: CommandDef<'slot.clear'> = {
  name: 'slot.clear',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => ({ slot: readInput(input, path, ['slot']).str('slot') }),
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    const { slot, entry } = findSlot(draft.puppet, input.slot);
    const tile = String(slot.tile);
    const prev = entry.slots[tile];
    if (prev === undefined) return { result: {}, warnings: [], inverse: [] };
    const fit = draft.images[prev]?.fit?.mode;
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- slots are keyed by tile index
    delete entry.slots[tile];
    return { result: {}, warnings: [], inverse: [{ name: 'slot.fill', input: fit === undefined ? { slot: input.slot, image: prev } : { slot: input.slot, image: prev, fit } }] };
  },
};
